<template>
	<div class="c-select__development" :id="id" :class="[{'is-open': isOpen}, {'c-select__development--no-label': !visibleLabel}]">
		<button
			@click="toggleSelect('click')"
			@keydown="triggerKeyPress($event)"
			ref="trigger"
			class="c-select__development__trigger"
			aria-haspopup="listbox"
			aria-expanded="false">
			<div class="c-select__development__container">
				<span class="c-select__development__label" :class="{'t-visually-hidden': !visibleLabel}">{{label}}</span>
				<span class="c-select__development__active" v-if="options[currentIndex]">{{options[currentIndex].display}}</span>
				<v-icon name="icon-arrow" size="xs" cssModifiers="c-select__development__icon"></v-icon>
			</div>
		</button>
		<ul
			class="c-select__development__list"
			@focusout="toggleSelect('focus')"
			@keydown="listKeyPress($event)"
			ref="list"
			role="listbox"
			tabindex="-1">
			<li class="c-select__development__option"
				:class="{'is-selected': index === selectedIndex}"
				:aria-selected="index === selectedIndex ? true : false"
				:id="id + '-option-' + index"
				:key="index"
				:data-value="option.value"
				v-for="(option, index) in options"
				@click="clickItem(index)"
				role="option">{{option.display}}</li>
		</ul>
	</div>
</template>

<script>
import VIcon from '../../../components/icon/VIcon.vue';

export default {
    name: 'VSelectDevelopment',
	components: {
		VIcon
	},
	props: {
		label: {
			type: String,
			default: null
		},
		selected: {
			type: Number,
			default: null
		},
		iconAtSmall: {
			type: String,
			default: ''
		},
		options: {
			type: Array,
			default: () => []
		},
		visibleLabel: {
			type: Boolean,
			default: true
		},
		id: {
			type: String
		}
	},
	data() {
		return {
			isOpen: false,
			readyToOpen: true,
			selectedIndex: 0,
			currentIndex: 0,
			maxIndex: 0
		}
	},
	methods: {
		/**
		 * Handle select list toggle
		 */
		toggleSelect(type) {
			if (this.isOpen) {
				this.isOpen = false;
				this.$refs.trigger.setAttribute('aria-expanded', 'false');
				this.$nextTick(() => {
					this.$refs.trigger.focus();
				});

				if (this.selectedIndex !== this.currentIndex) { /* Don't emit unless new option is selected */
					this.currentIndex = this.selectedIndex;
					this.$emit('optionSelected', this.options[this.currentIndex]);
				}

				this.readyToOpen = false;
				setTimeout(()=>{ this.readyToOpen = true; }, 200);
			} else if (!this.isOpen) {
				if (this.readyToOpen) {
					this.isOpen = true;
					this.$refs.trigger.setAttribute('aria-expanded', 'true');
					this.$nextTick(() => {
						this.$refs.list.focus();
					});
				}
			}
		},
		/**
		 * Handle option click
		 */
		clickItem(index) {
			this.selectedIndex = index;
			this.toggleSelect('item');
		},
		/**
		 * Handle trigger keypress
		 */
		triggerKeyPress(event) {
			switch (event.keyCode) {
				case 40: /* Arrow down */
				case 27: /* Escape */
				case 32: /* Space */
					event.preventDefault();
					this.toggleSelect('triggerKey');
					break;
				default:
					break;
			}
		},
		/**
		 * Handle list keypress
		 */
		listKeyPress(event) {
			switch (event.keyCode) {
				case 40: /* Arrow down */
					event.preventDefault();
					if (this.selectedIndex === this.maxIndex) {
						/* If selected option is at bottom, start from top */
						this.selectedIndex = 0;
					} else {
						this.selectedIndex = this.selectedIndex + 1;
					}
					break;
				case 38: /* Arrow up */
					event.preventDefault();
					if (this.selectedIndex === 0) {
						/* If selected option is at top, start from bottom */
						this.selectedIndex = this.maxIndex;
					} else {
						this.selectedIndex = this.selectedIndex - 1;
					}
					break;
				case 32: /* Space */
				case 27: /* Escape */
				case 13: /* Enter */
					event.preventDefault();
					this.toggleSelect('listKey');
					break;
				default:
					break;
			}

		}
	},
	watch: {
		selectedIndex() {
			this.$refs.list.setAttribute('aria-activedescendant', this.id + '-option-' + this.selectedIndex);
		}
	},
	mounted() {
		this.selectedIndex = this.selected;
		this.currentIndex = this.selectedIndex;
		this.maxIndex = this.options.length - 1;
	}
}
</script>
